import { Action } from 'redux';
import { ErrorAction } from '../index';
import { ForeignLanguageFeaturedPageResponse, GenresResponse } from '../api';

export const FOREIGN_LANGUAGE_PRODUCT_GROUPS_REQUEST = 'FOREIGN_LANGUAGE_PRODUCT_GROUPS_REQUEST';
export const FOREIGN_LANGUAGE_PRODUCT_GROUPS_SUCCESS = 'FOREIGN_LANGUAGE_PRODUCT_GROUPS_SUCCESS';
export const FOREIGN_LANGUAGE_PRODUCT_GROUPS_FAILURE = 'FOREIGN_LANGUAGE_PRODUCT_GROUPS_FAILURE';

export const FOREIGN_LANGUAGE_GENRES_REQUEST = 'FOREIGN_LANGUAGE_GENRES_REQUEST';
export const FOREIGN_LANGUAGE_GENRES_SUCCESS = 'FOREIGN_LANGUAGE_GENRES_SUCCESS';
export const FOREIGN_LANGUAGE_GENRES_FAILURE = 'FOREIGN_LANGUAGE_GENRES_FAILURE';

export const FOREIGN_LANGUAGE_SET_LANGUAGE = 'FOREIGN_LANGUAGE_SET_LANGUAGE';
export const FOREIGN_LANGUAGE_UNSET_LANGUAGE = 'FOREIGN_LANGUAGE_UNSET_LANGUAGE';

export const LOTE_SET_GENRE = 'LOTE_SET_GENRE';
export const LOTE_UNSET_GENRE = 'LOTE_UNSET_GENRE';

export type ForeignLanguageProductGroupsRequest = Action<typeof FOREIGN_LANGUAGE_PRODUCT_GROUPS_REQUEST>;
export type ForeignLanguageProductGroupsSuccess = {
    type: typeof FOREIGN_LANGUAGE_PRODUCT_GROUPS_SUCCESS;
    payload: ForeignLanguageFeaturedPageResponse;
};
export type ForeignLanguageProductGroupsFailure = ErrorAction<typeof FOREIGN_LANGUAGE_PRODUCT_GROUPS_FAILURE>;

export type ForeignLanguageGenresRequest = Action<typeof FOREIGN_LANGUAGE_GENRES_REQUEST>;
export type ForeignLanguageGenresSuccess = {
    type: typeof FOREIGN_LANGUAGE_GENRES_SUCCESS;
    payload: GenresResponse;
};
export type ForeignLanguageGenresFailure = ErrorAction<typeof FOREIGN_LANGUAGE_GENRES_FAILURE>;

export type ForeignLanguageSetLanguage = {
    type: typeof FOREIGN_LANGUAGE_SET_LANGUAGE;
    payload: string;
};
export type ForeignLanguageUnsetLanguage = Action<typeof FOREIGN_LANGUAGE_UNSET_LANGUAGE>;

export type LoteSetGenre = {
    type: typeof LOTE_SET_GENRE;
    payload: string;
};
export type LoteUnsetGenre = Action<typeof LOTE_UNSET_GENRE>;

export type ForeignLanguageAction =
    | ForeignLanguageProductGroupsRequest
    | ForeignLanguageProductGroupsSuccess
    | ForeignLanguageProductGroupsFailure
    | ForeignLanguageGenresRequest
    | ForeignLanguageGenresSuccess
    | ForeignLanguageGenresFailure
    | ForeignLanguageSetLanguage
    | ForeignLanguageUnsetLanguage
    | LoteSetGenre
    | LoteUnsetGenre;
